import {
  ICountry,
} from './authInterface';
import { RequestStatus } from 'mobx-store';
import { NotificationBatch } from 'screens/sendNotificationScreen/NotificationBatches/types';
import { NotificationType } from 'screens/sendNotificationScreen/types';

export interface INotification {
  notificationsList: Notification[];
  selectedNotification: Notification;
  loading: boolean;
  getNotificationRequestStatus: RequestStatus;
  addLoading: boolean;

  getNotifications(availableCountries: ICountry[]): Promise<void>;

  sendNewNotification(
    titleEn: string,
    bodyEn: string,
    titleAr: string,
    bodyAr: string,
    hideTitle: boolean,
    audience: string,
    imageEn: File[],
    imageAr: File[],
    file: File,
    link: string,
    type: string,
    navigationItemType: string,
    navigationItemId: number,
    countries: ICountry[],
    channelId: string,
    batches: NotificationBatch[],
    startDate: string,
    nativeModuleMethodName: string,
    nativeModuleName: string
  ): Promise<void>;

  resendNotification(id: number): Promise<void>;

  toggleNotificationBatchesStatus(id: number, status: boolean): Promise<void>;

  toggleNotificationScheduledStatus(id: number, status: boolean): Promise<void>;
}

export class Notification {
  id: number;

  title: string;

  imageURL: string;

  body: string;

  audience: "members" | "nonmembers" | "all" | "group";

  link: string;

  createdAt: string;

  type: NotificationType;

  scheduledSendTime: string;

  isBathces: boolean;

  isBatchesCanceled: boolean;

  isScheduledCanceled: boolean;

  nativeModuleMethodName: string;

  nativeModuleName: string;

  constructor() {
    this.id = 0;
    this.title = "";
    this.imageURL = "";
    this.body = "";
    this.audience = "all";
    this.link = "";
    this.createdAt = "";
    this.type = NotificationType.STATIC;
    this.scheduledSendTime = "";
    this.isBathces = false;
    this.isBatchesCanceled = false;
    this.isScheduledCanceled = false;
  }

  setId(id: number): void {
    this.id = id;
  }

  getId(): number {
    return this.id;
  }

  setTitle(newTitle: string): void {
    this.title = newTitle;
  }

  setType(type: NotificationType) {
    this.type = type;
  }

  setScheduledSendTime(sendTime: string) {
    this.scheduledSendTime = sendTime;
  }

  setCreatedAt(createdAt: string): void {
    this.createdAt = createdAt;
  }

  getTitle(): string {
    return this.title;
  }

  setBody(newBody: string): void {
    this.body = newBody;
  }

  getBody(): string {
    return this.body;
  }

  getImageUrl(): string {
    return this.imageURL;
  }

  setImageUrl(imageURL: string): void {
    this.imageURL = imageURL;
  }

  getAudience(): string {
    return this.audience;
  }

  getType(): string {
    return this.type;
  }

  getScheduledSendTime(): string {
    return this.scheduledSendTime;
  }

  getCreatedAt(): string {
    return this.createdAt;
  }

  getIsBatches(): boolean {
    return this.isBathces;
  }

  getIsBatchesCanceled(): boolean {
    return this.isBatchesCanceled;
  }

  getIsScheduledCanceled(): boolean {
    return this.isScheduledCanceled;
  }

  setIsBatches(isBathces: boolean): boolean {
    return (this.isBathces = isBathces);
  }

  setIsBatchesCanceled(isBatchesCanceled: boolean): boolean {
    return (this.isBatchesCanceled = isBatchesCanceled);
  }

  setIsScheduledCanceled(isScheduledCanceled: boolean): boolean {
    return (this.isScheduledCanceled = isScheduledCanceled);
  }

  setNativeScreenName(name: string): string {
    return (this.nativeModuleName = name);
  }

  setNativeMethodName(name: string): string {
    return (this.nativeModuleMethodName = name);
  }

  setAudience(audience: "members" | "nonmembers" | "all" | "group"): void {
    this.audience = audience;
  }

  getLink(): string {
    return this.link;
  }

  setLink(link: string): void {
    this.link = link;
  }
}

export class NotificationsChannel {
      name: string;
      id: string;

      constructor(name: string, id: string) {
          this.name = name;
          this.id = id;
      }

      public static possibleValues = [
          new NotificationsChannel('Main Channel', 'main-channel'),
          new NotificationsChannel('Deglawy Family Ads', 'deglawy-family-ads'),
          new NotificationsChannel('Deglawy Family Announcement', 'deglawy-family-announcement'),
          new NotificationsChannel('Degalawy Family Transaction', 'degalawy-family transaction'),
          new NotificationsChannel('General Ads', 'general-ads'),
          new NotificationsChannel('Renewal Success', 'renewal-success'),
          new NotificationsChannel('Super Deglawy', 'super-deglawy'),
          new NotificationsChannel('Announcement', 'announcement'),
          new NotificationsChannel('Clubs Occupancy', 'clubs-occupancy')
      ];

}
  

export enum NotificationSelection {
  BATCHES = "BATCHES",
  BULK = "BULK",
  ALL = "ALL",
}
